import Store from '@/store';
import PTC_Produtos from '@/api/PTC/PTC_Produtos.client';
import Notifier from '@/libs/Notifier';

export default class PTC_ProdutoService {
  constructor() {
    this.client = new PTC_Produtos();
    this.store = Store;
    this.notify = new Notifier();
  }

  async retornaProduto(query) {
    try {
      this.store.commit('PTC_ProdutosClient/SET_PRODUTOS', true);
      const data = await this.client.retornaProdutos(query);
      this.store.commit('PTC_ProdutosClient/SET_PRODUTOS', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_ProdutosClient/SET_IS_LOADING', false);
    }
  }

  async filtrosList() {
    try {
      this.store.commit('PTC_ProdutosClient/SET_IS_LOADING', true);
      const data = await this.client.filtrosList();
      this.store.commit('PTC_ProdutosClient/SET_FILTROS', data);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_ProdutosClient/SET_IS_LOADING', false);
    }
  }
}
